import { CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Router } from './router';
import { CustomerProvider } from './customer';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1d4ed8',
      dark: '#1e40af',
      light: '#dbeafe',
      contrastText: '#ffffff',
    },
    secondary: { main: '#0f172a' },
    success: { main: '#15803d', light: '#dcfce7', dark: '#166534' },
    warning: { main: '#b45309', light: '#fef3c7', dark: '#92400e' },
    error:   { main: '#b91c1c', light: '#fee2e2', dark: '#991b1b' },
    info:    { main: '#0369a1', light: '#e0f2fe' },
    background: { default: '#f1f5f9', paper: '#ffffff' },
    text: { primary: '#0f172a', secondary: '#64748b', disabled: '#94a3b8' },
    divider: '#e2e8f0',
    grey: {
      50:  '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
    },
  },
  typography: {
    fontFamily: '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    fontSize: 14,
    h1: { fontWeight: 700, letterSpacing: '-0.3px' },
    h2: { fontWeight: 700, letterSpacing: '-0.3px' },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700, fontSize: '1.5rem', letterSpacing: '-0.3px' },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 500 },
    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 600 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
      },
    },
    MuiButton: {
      defaultProps: { variant: 'contained', disableElevation: true },
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 500, borderRadius: 8 },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0 },
    },
    MuiTextField: {
      defaultProps: {
        sx: { mt: 2, mb: 0 },
        variant: 'outlined',
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        sx: { m: 0 },
      },
    },
    MuiSelect: {
      defaultProps: { variant: 'outlined' },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#0f172a',
          fontSize: 12,
          fontWeight: 500,
          padding: '6px 10px',
          borderRadius: 6,
        },
        arrow: { color: '#0f172a' },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CustomerProvider>
        <Router />
      </CustomerProvider>
    </ThemeProvider>
  );
}
